// These keys should match the GroupDataType enum in TRAPP and are used for making
// API requests for data sets
export enum GroupDataType {
	MEMBERS = 'members',
	SHARES = 'shares',
	DISCUSSION_TOPICS = 'discussion_topics',
	DISCUSSION_VIEWS = 'discussion_views',
	DISCUSSION_POSTS = 'discussion_posts',
	EVENT_MEMBERS = 'event_members',
	EVENT_VIEWS = 'event_views',
	GROUP_VIEWS = 'group_views',
	EVENT_CREATIONS = 'event_creations',
	FILE_DOWNLOADS = 'file_downloads',
}

export enum GroupDataRange {
	LAST_30_DAYS = 30,
	LAST_90_DAYS = 90,
	LAST_1_YEAR = 365,
}

export enum GroupDataBucket {
	ONE_DAY = '1d',
	ONE_MONTH = '1m',
}

export type GroupsDataResponse = Record<string, GroupDataResponse[]>;

export interface GroupDataResponse {
	keyName: string;
	totalBeforeStart: number;
	dataPoints: DataCount[];
}

export interface DataCount {
	date: Date;
	count: number;
}
